import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PageLoadingSpinner } from 'ui_kit_qmd'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from './app/store'
import App from './App'
import '@quickmd-llc/design-system/components/toast/Toast.css'
import '@quickmd-llc/design-system/patchQuillClipboard'
import './index.css'
import { initSentry } from './utils/sentryUtility'
import { isDeployedToProduction } from './utils/isDeployedToProduction'
import { initOrvalTokenModules } from './api/initOrvalTokenModules'

if (isDeployedToProduction) {
  Object.keys(console).forEach((key) => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Console has no index signature; widening via unknown is the only way to overwrite methods without enumerating each one
    ;(console as unknown as Record<string, () => void>)[key] = () => {}
  })
}

// we want to call this as early as possible so that whenever orval is used, the module setters exist/have been set, and
// the token getters will actually work
initOrvalTokenModules()
initSentry()

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root element not found')
}

const root = createRoot(container)

root.render(
  <Provider store={store}>
    <PersistGate loading={<PageLoadingSpinner />} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
)
